import {
  TypeUserPreferenceName,
  UserPreference,
} from '@/lib/api/accountManager/types';
import { Language } from '@/utils/translations/types/TypeLanguagesAndLocales';

export enum PreferenceCard {
  Sms = 'sms',
  Email = 'email',
}

export type PreferenceCardType = PreferenceCard.Sms | PreferenceCard.Email;

export const SMS_PREFERENCES: Array<TypeUserPreferenceName> = [
  UserPreference.SmsTransactional,
  UserPreference.SmsMarketing,
];

export const EMAIL_PREFERENCES: Array<TypeUserPreferenceName> = [
  UserPreference.EmailMarketing,
];

export const PreferenceTranslationKeyMap: Partial<
  Record<TypeUserPreferenceName, string>
> = {
  [UserPreference.EmailMarketing]: 'marketingLabel',
  [UserPreference.SmsMarketing]: 'marketingLabel',
  [UserPreference.SmsTransactional]: 'transactionalLabel',
};

export const LanguageTranslationKeyMap: Record<Language, string> = {
  [Language.English]: 'englishLanguageOptionLabel',
  [Language.French]: 'frenchLanguageOptionLabel',
  [Language.Spanish]: 'spanishLanguageOptionLabel',
  [Language.German]: 'germanLanguageOptionLabel',
  [Language.Dutch]: 'dutchLanguageOptionLabel',
};
